import React from 'react';
import * as style from './circleButton.module.scss';

const getClassName = (type, active) => {
  switch (type) {
    case 'play':
      return style.circlePlay;
    case 'close':
      return style.circleX;
    case 'open':
      return style.circlePlus;
    case 'left':
      return `${active === false ? style.inactiveCircleArrow : style.circleArrow} ${style.prev}`;
    case 'arrow':
      return active === false ? style.inactiveCircleArrow : style.circleArrow;
    default:
      return style.circleButton;
  }
};

const CircleButton = props => {
  const {
    type,
    active = true,
    isButton = true,
    direction,
    handleClick,
    bigger,
    smallLeft,
    biggest,
    textRight,
    textStyleAlt,
    textWhite,
    kicker,
    text,
  } = props;

  // Map direction prop to type for arrow button behavior
  const resolvedType = direction
    ? direction === 'left'
      ? 'left'
      : 'arrow'
    : type;

  const className = `${getClassName(resolvedType, active)} ${
    bigger ? style.bigger : ''
  } ${smallLeft ? style.smallLeft : ''}
    ${biggest ? style.biggest : ''}`;

  const content = text || kicker ? (
    <span
      className={`${
        textRight ? style.buttonTextRight : style.buttonText
      } ${textStyleAlt ? style.textStyleAlt : ''} ${
        textWhite ? style.textWhite : ''
      } ${kicker ? style.hasKicker : ''}`}
    >
      {kicker && (
        <span className={`f-label ${style.kicker}`}>{kicker}</span>
      )}
      {text}
    </span>
  ) : null;

  if (isButton === false) {
    return (
      <div
        className={className}
        onClick={handleClick}
      >
        {content}
      </div>
    );
  }

  return (
    <button
      className={className}
      onClick={handleClick}
      onMouseLeave={e => {
        // don't preserve focus state if mouseing out after click
        e.target.blur();
      }}
    >
      {content}
    </button>
  );
};
export default CircleButton;
